import * as TT from "../../libs/Tooltip";
import React from "react";
import { MAIN_VIEW as MV } from "../../constants/MainView";
import * as UrlHelpers from "../../libs/UrlHelpers";
import AppsStore from "../../stores/AppsStore";
import SelectionStore, { getSelectionCount, getSelectionText } from "../../stores/SelectionStore";
import { TYPES } from "../../constants/Tooltip";
import { Link } from "react-router-dom";

export default function HeaderMySelection() {
  const isHeaderFixed = AppsStore.getIsHeaderFixed();

  // not render for main view selection and phone layout
  if (UrlHelpers.getMainView() === MV.SELECTION || AppsStore.getLayoutView() === "phone") return <i />;

  // prevent rendering duplicate selection item while header is not fixed
  if (!isHeaderFixed) return null;

  const classNameEditing = SelectionStore.isEditing() ? "counter-editing" : "";

  return (
    <li className={`view-nav__item view-nav__item--add-item`}>
      <Link to={UrlHelpers.getLinkPathForSelection()}>
        <span className={`my-selection__counter ${classNameEditing}`} style={{ position: "relative", zIndex: 5 }}>
          {getSelectionCount()}
        </span>
        <span
          className="ficon ficon__my-selection my-selection__flag view-nav-item__icon view-nav-item__icon__notepad"
          style={{ position: "relative", top: "-36px" }}
          onMouseOver={TT.showTooltip.bind(this, getSelectionText(), TYPES.center, 15)}
          onMouseOut={TT.removeTooltip.bind(this, TYPES.center)}
          onMouseDown={TT.removeTooltip.bind(this, TYPES.center)}
        />
      </Link>
    </li>
  );
}
